import { Spin } from 'antd';
import useThemeActivitiesSelector from './useThemeActivitiesSelector.hook';
import { StyledThemeActivitiesSelector } from './ThemeActivitiesSelector.styled';
import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import Colors from '@/constants/Colors';
import Button from '@/shared/Button/Button';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getLabelForList } from '@/constants/ActivityTypeLabelsTeacher';

export default function ThemeActivitiesSelector({
  editorActive,
  theme,
  initialActivityIds,
  onActivitiesSelected,
}) {
  const { state, actions } = useThemeActivitiesSelector({
    theme,
    initialActivityIds,
    onActivitiesSelected,
  });

  if (state.loading) {
    return <Spin />;
  }

  const restOfActivities = state.allActivities.filter(
    (activity) => !state.selectedActivities.some((a) => a.id == activity.id)
  );

  return (
    <StyledThemeActivitiesSelector>
      <div className="column">
        <div className="activities-wrapper">
          <strong>Activities you will add:</strong>
          <div className="activities">
            {state.selectedActivities.map((activity) => (
              <ActivityRow
                allActivities={state.allActivities}
                editorActive={editorActive}
                activity={activity}
                key={activity.id}
                selected
                action={
                  <Button
                    size="small"
                    type="danger"
                    ghost
                    shape="circle"
                    icon={<DeleteOutlined />}
                    onClick={() => actions.removeSelectedActivity(activity.id)}
                  />
                }
              />
            ))}
          </div>
        </div>
      </div>
      {editorActive && restOfActivities?.length > 0 && (
        <div className="column">
          <div className="activities-wrapper">
            <strong>Activities you can add:</strong>
            <div className="activities">
              {restOfActivities.map((activity) => (
                <ActivityRow
                  allActivities={state.allActivities}
                  editorActive={editorActive}
                  activity={activity}
                  key={activity.id}
                  action={
                    <Button
                      size="small"
                      shape="circle"
                      icon={<PlusOutlined />}
                      onClick={() => actions.addSelectedActivity(activity)}
                    />
                  }
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </StyledThemeActivitiesSelector>
  );
}

function ActivityRow({
  allActivities,
  editorActive,
  activity,
  selected,
  action,
}) {
  return (
    <div className={`activity ${selected ? 'selected' : ''}`}>
      <ActivityTypeIcon
        type={activity.type}
        withCircle={true}
        color="white"
        circleColor={Colors.activityTypeColors[activity.type]}
        size={10}
        width={20}
        height={20}
      />
      <span>
        {getLabelForList({
          activity: activity,
          activities: allActivities,
        })}
      </span>

      {editorActive ? <div className="actions">{action}</div> : null}
    </div>
  );
}
